var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41444 11.2425H23C23.5523 11.2425 24 11.6902 24 12.2425C24 12.7948 23.5523 13.2425 23 13.2425H3.41399L10.9497 20.7781C11.3402 21.1687 11.3402 21.8018 10.9497 22.1923C10.5591 22.5829 9.92596 22.5829 9.53544 22.1923L0.312425 12.9693L0.298597 12.9552C0.114284 12.7738 0 12.5215 0 12.2425C0 11.9599 0.117205 11.7047 0.305654 11.5228L9.53559 2.29289C9.92611 1.90237 10.5593 1.90237 10.9498 2.29289C11.3403 2.68342 11.3403 3.31658 10.9498 3.70711L3.41444 11.2425Z",
    fill: "#8B8AAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.2df5b7f470165e5b38696534e1638a7f.svg";
export { ForwardRef as ReactComponent };